import React, { useState, useCallback, useEffect, useRef } from "react";
import "./App.css";

/* ═══════════════════ Pixel SVG Icons ═══════════════════ */
const pxSvg = { imageRendering: "pixelated" };
function PxIcon({ name, size = 28, className = "" }) {
  const w = size,
    h = size;
  const icons = {
    coin: (
      <svg
        viewBox="0 0 8 8"
        width={w}
        height={h}
        style={pxSvg}
        className={className}
      >
        <rect x="2" y="0" width="4" height="1" fill="#ffcc00" />
        <rect x="1" y="1" width="6" height="6" fill="#ffcc00" />
        <rect x="2" y="7" width="4" height="1" fill="#ffcc00" />
        <rect x="0" y="2" width="1" height="4" fill="#ffcc00" />
        <rect x="7" y="2" width="1" height="4" fill="#ffcc00" />
        <rect x="3" y="2" width="2" height="1" fill="#996600" />
        <rect x="3" y="5" width="2" height="1" fill="#996600" />
        <rect x="4" y="3" width="1" height="2" fill="#996600" />
      </svg>
    ),
    skull: (
      <svg
        viewBox="0 0 8 8"
        width={w}
        height={h}
        style={pxSvg}
        className={className}
      >
        <rect x="2" y="0" width="4" height="1" fill="#8899aa" />
        <rect x="1" y="1" width="6" height="5" fill="#8899aa" />
        <rect x="0" y="2" width="1" height="3" fill="#8899aa" />
        <rect x="7" y="2" width="1" height="3" fill="#8899aa" />
        <rect x="1" y="2" width="2" height="2" fill="#112" />
        <rect x="5" y="2" width="2" height="2" fill="#112" />
        <rect x="2" y="6" width="1" height="2" fill="#8899aa" />
        <rect x="5" y="6" width="1" height="2" fill="#8899aa" />
        <rect x="3" y="5" width="2" height="1" fill="#112" />
      </svg>
    ),
    swap: (
      <svg
        viewBox="0 0 8 8"
        width={w}
        height={h}
        style={pxSvg}
        className={className}
      >
        <rect x="2" y="1" width="6" height="1" fill="#cc66ff" />
        <rect x="6" y="0" width="2" height="3" fill="#cc66ff" />
        <rect x="0" y="5" width="6" height="1" fill="#cc66ff" />
        <rect x="0" y="4" width="2" height="3" fill="#cc66ff" />
      </svg>
    ),
    eye: (
      <svg
        viewBox="0 0 8 8"
        width={w}
        height={h}
        style={pxSvg}
        className={className}
      >
        <rect x="2" y="1" width="4" height="1" fill="#00ccff" />
        <rect x="1" y="2" width="6" height="4" fill="#00ccff" />
        <rect x="0" y="3" width="1" height="2" fill="#00ccff" />
        <rect x="7" y="3" width="1" height="2" fill="#00ccff" />
        <rect x="3" y="3" width="2" height="2" fill="#ffffff" />
        <rect x="2" y="6" width="4" height="1" fill="#00ccff" />
      </svg>
    ),
    bolt: (
      <svg
        viewBox="0 0 8 8"
        width={w}
        height={h}
        style={pxSvg}
        className={className}
      >
        <rect x="4" y="0" width="2" height="2" fill="#ffcc00" />
        <rect x="3" y="2" width="2" height="1" fill="#ffcc00" />
        <rect x="2" y="3" width="4" height="1" fill="#ffcc00" />
        <rect x="3" y="4" width="2" height="1" fill="#ffcc00" />
        <rect x="2" y="5" width="2" height="2" fill="#ffcc00" />
      </svg>
    ),
    star: (
      <svg
        viewBox="0 0 8 8"
        width={w}
        height={h}
        style={pxSvg}
        className={className}
      >
        <rect x="3" y="0" width="2" height="2" fill="#ffcc00" />
        <rect x="0" y="2" width="8" height="2" fill="#ffcc00" />
        <rect x="1" y="4" width="6" height="1" fill="#ffcc00" />
        <rect x="2" y="5" width="4" height="1" fill="#ffcc00" />
        <rect x="1" y="6" width="2" height="2" fill="#ffcc00" />
        <rect x="5" y="6" width="2" height="2" fill="#ffcc00" />
      </svg>
    ),
    diamond: (
      <svg
        viewBox="0 0 10 10"
        width={w}
        height={h}
        style={pxSvg}
        className={className}
      >
        {/* Table (flat top) */}
        <rect x="2" y="0" width="6" height="1" fill="#eeffff" />
        {/* Crown */}
        <rect x="1" y="1" width="3" height="1" fill="#88eeff" />
        <rect x="4" y="1" width="2" height="1" fill="#ccffff" />
        <rect x="6" y="1" width="3" height="1" fill="#55ccdd" />
        {/* Girdle */}
        <rect x="0" y="2" width="4" height="1" fill="#66ddee" />
        <rect x="4" y="2" width="2" height="1" fill="#bbffff" />
        <rect x="6" y="2" width="4" height="1" fill="#33bbcc" />
        {/* Pavilion — center highlight V */}
        <rect x="1" y="3" width="3" height="1" fill="#55ccdd" />
        <rect x="4" y="3" width="2" height="1" fill="#99eeff" />
        <rect x="6" y="3" width="3" height="1" fill="#2299bb" />
        <rect x="1" y="4" width="3" height="1" fill="#44bbcc" />
        <rect x="4" y="4" width="2" height="1" fill="#88ddee" />
        <rect x="6" y="4" width="3" height="1" fill="#1188aa" />
        <rect x="2" y="5" width="2" height="1" fill="#33aacc" />
        <rect x="4" y="5" width="2" height="1" fill="#77ccdd" />
        <rect x="6" y="5" width="2" height="1" fill="#0088aa" />
        <rect x="3" y="6" width="1" height="1" fill="#2299bb" />
        <rect x="4" y="6" width="2" height="1" fill="#55bbcc" />
        <rect x="6" y="6" width="1" height="1" fill="#007799" />
        <rect x="3" y="7" width="1" height="1" fill="#1188aa" />
        <rect x="4" y="7" width="2" height="1" fill="#44aabc" />
        <rect x="6" y="7" width="1" height="1" fill="#006688" />
        {/* Taper to point */}
        <rect x="4" y="8" width="1" height="1" fill="#1199aa" />
        <rect x="5" y="8" width="1" height="1" fill="#005577" />
        <rect x="4" y="9" width="2" height="1" fill="#006688" />
      </svg>
    ),
    crown: (
      <svg
        viewBox="0 0 12 8"
        width={w}
        height={h}
        style={pxSvg}
        className={className}
      >
        {/* Peak tips */}
        <rect x="1" y="0" width="1" height="1" fill="#ffcc00" />
        <rect x="5" y="0" width="2" height="1" fill="#ffcc00" />
        <rect x="10" y="0" width="1" height="1" fill="#ffcc00" />
        {/* Peak bodies (with valleys at x=3 and x=8) */}
        <rect x="0" y="1" width="3" height="3" fill="#ffcc00" />
        <rect x="4" y="1" width="4" height="3" fill="#ffcc00" />
        <rect x="9" y="1" width="3" height="3" fill="#ffcc00" />
        {/* Band */}
        <rect x="0" y="4" width="12" height="2" fill="#ffcc00" />
        {/* Jewels */}
        <rect x="2" y="5" width="1" height="1" fill="#ff4444" />
        <rect x="5" y="5" width="2" height="1" fill="#ff4444" />
        <rect x="9" y="5" width="1" height="1" fill="#ff4444" />
        {/* Base */}
        <rect x="0" y="6" width="12" height="2" fill="#aa7700" />
      </svg>
    ),
    pencil: (
      <svg
        viewBox="0 0 10 10"
        width={w}
        height={h}
        style={pxSvg}
        className={className}
      >
        {/* Eraser */}
        <rect x="8" y="0" width="2" height="1" fill="#ff8888" />
        <rect x="7" y="1" width="2" height="1" fill="#ff8888" />
        {/* Metal band */}
        <rect x="6" y="2" width="2" height="1" fill="#aabbcc" />
        {/* Body */}
        <rect x="5" y="3" width="2" height="1" fill="#ffcc00" />
        <rect x="4" y="4" width="2" height="1" fill="#ffcc00" />
        <rect x="3" y="5" width="2" height="1" fill="#ffcc00" />
        <rect x="2" y="6" width="2" height="1" fill="#ffcc00" />
        {/* Wood tip */}
        <rect x="1" y="7" width="2" height="1" fill="#cc8844" />
        <rect x="0" y="8" width="2" height="1" fill="#cc8844" />
        {/* Graphite point */}
        <rect x="0" y="9" width="1" height="1" fill="#888888" />
      </svg>
    ),
    arrowR: (
      <svg
        viewBox="0 0 5 8"
        width={w * 0.625}
        height={h}
        style={pxSvg}
        className={className}
      >
        <rect x="0" y="0" width="1" height="8" fill="#ffcc00" />
        <rect x="1" y="1" width="1" height="6" fill="#ffcc00" />
        <rect x="2" y="2" width="1" height="4" fill="#ffcc00" />
        <rect x="3" y="3" width="1" height="2" fill="#ffcc00" />
        <rect x="4" y="3.5" width="1" height="1" fill="#ffcc00" />
      </svg>
    ),
    shield: (
      <svg
        viewBox="0 0 8 8"
        width={w}
        height={h}
        style={pxSvg}
        className={className}
      >
        <rect x="1" y="0" width="6" height="1" fill="#00ccff" />
        <rect x="0" y="1" width="8" height="4" fill="#00ccff" />
        <rect x="1" y="5" width="6" height="1" fill="#00ccff" />
        <rect x="2" y="6" width="4" height="1" fill="#00ccff" />
        <rect x="3" y="7" width="2" height="1" fill="#00ccff" />
        <rect x="3" y="2" width="2" height="3" fill="#88eeff" />
        <rect x="2" y="3" width="4" height="1" fill="#88eeff" />
      </svg>
    ),
    menu: (
      <svg
        viewBox="0 0 8 8"
        width={w}
        height={h}
        style={pxSvg}
        className={className}
      >
        <rect x="1" y="1" width="6" height="1" fill="currentColor" />
        <rect x="1" y="3" width="6" height="1" fill="currentColor" />
        <rect x="1" y="5" width="6" height="1" fill="currentColor" />
      </svg>
    ),
    close: (
      <svg
        viewBox="0 0 8 8"
        width={w}
        height={h}
        style={pxSvg}
        className={className}
      >
        <rect x="1" y="1" width="1" height="1" fill="currentColor" />
        <rect x="2" y="2" width="1" height="1" fill="currentColor" />
        <rect x="3" y="3" width="2" height="2" fill="currentColor" />
        <rect x="5" y="5" width="1" height="1" fill="currentColor" />
        <rect x="6" y="6" width="1" height="1" fill="currentColor" />
        <rect x="6" y="1" width="1" height="1" fill="currentColor" />
        <rect x="5" y="2" width="1" height="1" fill="currentColor" />
        <rect x="2" y="5" width="1" height="1" fill="currentColor" />
        <rect x="1" y="6" width="1" height="1" fill="currentColor" />
      </svg>
    ),
  };
  return (
    <span className="inline-flex items-center justify-center">
      {icons[name] || null}
    </span>
  );
}

const PROP_ICON_MAP = { peek: "eye", swap: "swap", double: "bolt" };

/* ═══════════════════ Constants ═══════════════════ */
const PLAYERS = [
  "選手 1",
  "選手 2",
  "選手 3",
  "選手 4",
  "選手 5",
  "選手 6",
  "選手 7",
  "選手 8",
  "選手 9",
];
const TOTAL_ROUNDS = 6;
const TOTAL_CARDS = 60;

const DEFAULT_MONEY_TIERS = [
  { value: 5000, count: 2 },
  { value: 3000, count: 6 },
  { value: 2000, count: 12 },
  { value: 1000, count: 24 },
];
const PROP_TOTAL = 6; // swap×2 + peek×2 + double×2

const CARD_TYPES = {
  MONEY_5000: {
    type: "money",
    value: 5000,
    label: "$5,000",
    icon: "coin",
    count: 2,
  },
  MONEY_3000: {
    type: "money",
    value: 3000,
    label: "$3,000",
    icon: "coin",
    count: 6,
  },
  MONEY_2000: {
    type: "money",
    value: 2000,
    label: "$2,000",
    icon: "coin",
    count: 12,
  },
  MONEY_1000: {
    type: "money",
    value: 1000,
    label: "$1,000",
    icon: "coin",
    count: 24,
  },
  NOTHING: {
    type: "nothing",
    value: 0,
    label: "銘謝惠顧",
    icon: "skull",
    count: 10,
  },
  SWAP: { type: "prop", prop: "swap", label: "交換卡", icon: "swap", count: 2 },
  PEEK: { type: "prop", prop: "peek", label: "偷看卡", icon: "eye", count: 2 },
  DOUBLE: {
    type: "prop",
    prop: "double",
    label: "雙倍卡",
    icon: "bolt",
    count: 2,
  },
};

/* ═══════════════════ Quiz ═══════════════════ */
const QUIZ_QUESTIONS = [
  { question: "JM 的本名？", options: ["黃章銘", "黃禺諦"], correctIndex: 0 },
  { question: "老闆叫什麼？", options: ["詹惟純", "詹惟淳"], correctIndex: 1 },
  { question: "阿昆的本名？", options: ["陸昆峮", "陸盈君"], correctIndex: 1 },
  { question: "誰的年紀比較小？", options: ["許雅婷", "胡雅婷"], correctIndex: 1 },
  { question: "誰不住在台北？", options: ["Cara", "小邱"], correctIndex: 0 },
  { question: "+Ming 上次去哪裡玩？", options: ["東京", "福岡"], correctIndex: 0 },
  { question: "誰沒有脂肪肝？", options: ["JM", "Rita"], correctIndex: 1 },
  { question: "誰家裡有養貓咪？", options: ["Cara", "Trista"], correctIndex: 1 },
];
const QUIZ_COUNT = 8;

/* ═══════════════════ SFX ═══════════════════ */
const sfxCache = {};
function playSfx(name) {
  if (!sfxCache[name]) sfxCache[name] = new Audio(`/${name}`);
  const a = sfxCache[name];
  a.currentTime = 0;
  a.play().catch(() => {});
}
const sfxHover = () => playSfx("sound_button_hover.wav");
const sfxCtaClick = () => playSfx("sound_cta_click.wav");
const sfxClick = () => playSfx("sound_button_click.wav");

/* ═══════════════════ Helpers ═══════════════════ */
function generateDeck(tiers) {
  const mt = tiers || DEFAULT_MONEY_TIERS;
  const deck = [];
  /* Money cards from tiers */
  mt.forEach((t) => {
    for (let i = 0; i < t.count; i++)
      deck.push({
        type: "money",
        value: t.value,
        label: "$" + t.value.toLocaleString(),
        icon: "coin",
      });
  });
  /* Prop cards (fixed) */
  [CARD_TYPES.SWAP, CARD_TYPES.PEEK, CARD_TYPES.DOUBLE].forEach((ct) => {
    for (let i = 0; i < ct.count; i++) deck.push({ ...ct, count: undefined });
  });
  /* Nothing cards — auto-fill remaining */
  const nothingCount = TOTAL_CARDS - deck.length;
  for (let i = 0; i < nothingCount; i++)
    deck.push({ type: "nothing", value: 0, label: "銘謝惠顧", icon: "skull" });
  /* Shuffle */
  for (let i = deck.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [deck[i], deck[j]] = [deck[j], deck[i]];
  }
  /* Assign quiz to random $1000 cards */
  const minTierValue = Math.min(...mt.map((t) => t.value));
  const quizCandidates = [];
  deck.forEach((c, i) => {
    if (c.type === "money" && c.value === minTierValue) quizCandidates.push(i);
  });
  /* Shuffle candidates and pick up to QUIZ_COUNT */
  for (let i = quizCandidates.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [quizCandidates[i], quizCandidates[j]] = [quizCandidates[j], quizCandidates[i]];
  }
  const shuffledQ = [...QUIZ_QUESTIONS];
  for (let i = shuffledQ.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledQ[i], shuffledQ[j]] = [shuffledQ[j], shuffledQ[i]];
  }
  const quizPicks = quizCandidates.slice(0, QUIZ_COUNT);
  quizPicks.forEach((deckIdx, i) => {
    deck[deckIdx].quiz = shuffledQ[i % shuffledQ.length];
  });
  return deck.map((c, idx) => ({
    ...c,
    id: idx,
    flipped: false,
    flippedBy: null,
  }));
}
function initPlayers(names) {
  return (names || PLAYERS).map((name, i) => ({
    id: i,
    name,
    totalMoney: 0,
    props: [],
    roundFlipped: false,
    lastFlippedValue: 0,
    lastFlippedCardId: null,
    doubleActive: false,
  }));
}
function fmt(v) {
  return "$" + v.toLocaleString();
}
function fmtResult(v) {
  if (typeof v === "string") return v;
  return v > 0 ? fmt(v) : "銘謝惠顧";
}

/* ═══════════════════ GameCard ═══════════════════ */
function GameCard({ card, onClick, peekingId }) {
  const flipped = card.flipped;
  const peeking = peekingId === card.id;
  const show = flipped || peeking;

  const faceClass =
    card.type === "money"
      ? "pixel-card-money"
      : card.type === "prop"
      ? "pixel-card-prop"
      : "pixel-card-nothing";

  const canInteract = !flipped;

  return (
    <div
      className={`perspective-card w-full h-full ${
        canInteract ? "cursor-pointer" : ""
      }`}
      onClick={() => {
        if (canInteract) playSfx("sound_card_click.wav");
        onClick(card.id);
      }}
      onMouseEnter={() => {
        if (canInteract) playSfx("sound_card_hover.wav");
      }}
    >
      <div
        className={`relative w-full h-full preserve-3d ${show ? "flip-y" : ""}`}
      >
        <div
          className={`absolute inset-0 backface-hidden pixel-card-back
                        flex items-center justify-center select-none
                        ${
                          canInteract
                            ? "hover:border-[#00ccff] hover:shadow-[0_0_14px_rgba(0,204,255,0.4)] hover:-translate-y-1 transition-all duration-100"
                            : ""
                        }`}
        >
          <PxIcon name="shield" size={28} />
        </div>
        <div
          className={`absolute inset-0 backface-hidden flip-y ${faceClass}
                        flex flex-col items-center justify-center gap-0.5
                        ${peeking && !flipped ? "ring-2 ring-[#39ff14]" : ""}`}
        >
          <PxIcon name={card.icon} size={28} />
          <span
            className={`text-base leading-tight
            ${
              card.type === "money"
                ? "text-gradient-gold"
                : card.type === "prop"
                ? "text-gradient-purple"
                : "text-[#556]"
            }`}
          >
            {card.label}
          </span>
          {peeking && !flipped && (
            <span className="absolute bottom-0.5 text-xs text-[#39ff14] anim-blink">
              PEEK
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════ Overlay ═══════════════════ */
function Overlay({ children }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
      <div className="pixel-panel-gold p-8 sm:p-10 max-w-3xl w-[96%] anim-scale">
        {children}
      </div>
    </div>
  );
}

/* ═══════════════════ PeekConfirmModal ═══════════════════ */
function PeekConfirmModal({ show, card, onConfirm, onCancel }) {
  if (!show || !card) return null;
  return (
    <Overlay>
      <div className="text-center">
        <div className="mb-4">
          <PxIcon name={card.icon} size={88} />
        </div>
        <p className="text-3xl sm:text-4xl text-gradient-cyan mb-3">
          -- 偷看結果 --
        </p>
        <p className="text-4xl sm:text-5xl text-gradient-gold mb-5">
          {card.label}
        </p>
        <p className="text-2xl sm:text-3xl text-[#8899bb] mb-6">
          是否要抽這張卡片？
        </p>
        <div className="flex gap-4">
          <button
            onClick={onCancel}
            className="flex-1 py-3 pixel-btn text-2xl sm:text-3xl"
          >
            不抽
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-3 pixel-btn-gold text-2xl sm:text-3xl"
          >
            抽卡！
          </button>
        </div>
      </div>
    </Overlay>
  );
}

/* ═══════════════════ SwapOfferModal ═══════════════════ */
function SwapOfferModal({
  show,
  playerName,
  currentValue,
  nextPlayerName,
  onAccept,
  onDecline,
}) {
  if (!show) return null;
  return (
    <Overlay>
      <div className="text-center">
        <div className="mb-4">
          <PxIcon name="swap" size={88} />
        </div>
        <p className="text-3xl sm:text-4xl text-gradient-purple mb-3">
          -- 交換卡 --
        </p>
        <p className="text-2xl sm:text-3xl text-[#8899bb] mb-2">
          {playerName} 本輪結果：
          <span className="text-gradient-gold">{fmtResult(currentValue)}</span>
        </p>
        <p className="text-2xl sm:text-3xl text-[#8899bb] mb-5">
          要與 <span className="text-gradient-cyan">{nextPlayerName}</span>{" "}
          交換結果嗎？
        </p>
        <p className="text-xl text-[#556] mb-5">交換後將獲得對方的抽卡結果</p>
        <div className="flex gap-4">
          <button
            onClick={onDecline}
            className="flex-1 py-3 pixel-btn text-2xl sm:text-3xl"
          >
            不換
          </button>
          <button
            onClick={onAccept}
            className="flex-1 py-3 pixel-btn-gold text-2xl sm:text-3xl"
          >
            交換！
          </button>
        </div>
      </div>
    </Overlay>
  );
}

/* ═══════════════════ TurnStartModal ═══════════════════ */
function TurnStartModal({ show, playerName, roundInfo, onConfirm }) {
  if (!show) return null;
  return (
    <Overlay>
      <div className="text-center">
        <div className="mb-4 anim-bounce inline-block">
          <PxIcon name="arrowR" size={88} />
        </div>
        {roundInfo && (
          <p className="text-2xl sm:text-3xl text-gradient-cyan mb-3">
            {roundInfo}
          </p>
        )}
        <p className="text-4xl sm:text-5xl text-gradient-gold mb-6">
          {playerName}
        </p>
        <button
          onClick={() => {
            sfxClick();
            onConfirm();
          }}
          onMouseEnter={sfxHover}
          className="w-full py-3 pixel-btn-gold text-2xl sm:text-3xl"
        >
          開始抽卡
        </button>
      </div>
    </Overlay>
  );
}

/* ═══════════════════ QuizModal ═══════════════════ */
function QuizModal({ show, question, options, onAnswer }) {
  if (!show || !question) return null;
  return (
    <Overlay>
      <div className="text-center">
        <div className="flex justify-center mb-4 anim-bounce">
          <PxIcon name="diamond" size={64} />
        </div>
        <p className="text-3xl sm:text-4xl text-gradient-gold mb-4">
          獎金翻倍挑戰
        </p>
        <p className="text-2xl sm:text-3xl text-[#ddeeff] mb-8 leading-relaxed">
          {question}
        </p>
        <div className="flex flex-col gap-4">
          {options.map((opt, i) => (
            <button
              key={i}
              onClick={() => {
                sfxCtaClick();
                onAnswer(i);
              }}
              onMouseEnter={sfxHover}
              className="w-full py-3 pixel-btn-gold text-2xl sm:text-3xl"
            >
              {opt}
            </button>
          ))}
        </div>
      </div>
    </Overlay>
  );
}

/* ═══════════════════ FinalResults ═══════════════════ */
function FinalResults({ players, onRestart }) {
  const sorted = [...players].sort((a, b) => b.totalMoney - a.totalMoney);
  const total = sorted.reduce((s, p) => s + p.totalMoney, 0);
  const top3 = sorted.slice(0, 3);
  const rest = sorted.slice(3);

  /* podium order: 2nd, 1st, 3rd */
  const podiumOrder = [top3[1], top3[0], top3[2]];
  const podiumCfg = [
    {
      rank: 2,
      h: "h-16",
      color: "text-[#aabbcc]",
      nameClass: "text-gradient-cyan",
    },
    {
      rank: 1,
      h: "h-24",
      nameClass: "text-gradient-gold",
    },
    {
      rank: 3,
      h: "h-12",
      nameClass: "text-gradient-cyan",
    },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/85">
      <div className="pixel-panel-gold p-6 sm:p-8 max-w-4xl w-[96%] anim-scale">
        {/* Title */}
        <div className="text-center mb-3">
          <p className="text-4xl sm:text-5xl text-gradient-gold anim-neon">
            遊戲結束
          </p>
          <p className="text-lg text-[#8899bb] mt-2">
            總獎金 <span className="text-gradient-green">{fmt(total)}</span>
          </p>
        </div>

        {/* Podium — top 3 */}
        <div className="flex items-end justify-center gap-3 sm:gap-5 mb-4">
          {podiumOrder.map((p, i) => {
            const cfg = podiumCfg[i];
            return (
              <div
                key={p.id}
                className="flex flex-col items-center"
                style={{ width: cfg.rank === 1 ? "38%" : "28%" }}
              >
                {/* crown for 1st */}
                {cfg.rank === 1 && (
                  <div className="anim-bounce mb-1">
                    <PxIcon name="crown" size={32} />
                  </div>
                )}
                <span
                  className="text-2xl sm:text-3xl mb-1"
                  style={{
                    color:
                      cfg.rank === 1
                        ? "#ffcc00"
                        : cfg.rank === 2
                        ? "#aabbcc"
                        : "#cc8844",
                  }}
                >
                  #{cfg.rank}
                </span>
                <span
                  className={`text-2xl sm:text-3xl ${cfg.nameClass} text-center truncate w-full`}
                >
                  {p.name}
                </span>
                <span className="text-gradient-green text-xl sm:text-2xl mt-0.5">
                  {fmt(p.totalMoney)}
                </span>
                {/* podium bar */}
                <div
                  className={`${cfg.h} w-full mt-2 rounded-t-sm`}
                  style={{
                    background:
                      cfg.rank === 1
                        ? "linear-gradient(180deg, #ffcc00 0%, #aa7700 100%)"
                        : cfg.rank === 2
                        ? "linear-gradient(180deg, #aabbcc 0%, #667788 100%)"
                        : "linear-gradient(180deg, #cc8844 0%, #885522 100%)",
                    boxShadow:
                      "inset 1px 1px 0 rgba(255,255,255,0.15), 0 0 8px rgba(0,0,0,0.4)",
                  }}
                />
              </div>
            );
          })}
        </div>

        {/* 4th–9th — 3×2 grid */}
        <div className="grid grid-cols-3 gap-2 mb-5">
          {rest.map((p, i) => (
            <div key={p.id} className="pixel-panel px-3 py-2.5 text-center">
              <span className="text-[#556] text-base sm:text-lg">#{i + 4}</span>
              <p className="text-gradient-cyan text-lg sm:text-xl truncate">
                {p.name}
              </p>
              <p className="text-gradient-green text-lg sm:text-xl">
                {fmt(p.totalMoney)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════ StartScreen ═══════════════════ */
function StartScreen({ onStart, teamName, gameName, moneyTiers }) {
  const moneyTotal = moneyTiers.reduce((s, t) => s + t.count, 0);
  const nothingCount = TOTAL_CARDS - moneyTotal - PROP_TOTAL;
  return (
    <div
      className="h-screen flex flex-col items-center overflow-y-auto
                    bg-pixel text-white scanlines p-4"
    >
      <div
        className="max-w-2xl w-full my-auto anim-scale"
        style={{ position: "relative", zIndex: 1 }}
      >
        {/* Title */}
        <div className="text-center mb-6">
          <div className="anim-bounce inline-block mb-3">
            <span
              className="text-5xl sm:text-6xl anim-neon tracking-widest"
              style={{
                background:
                  "linear-gradient(180deg, #ffd080 0%, #ffa73b 50%, #cc6600 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              {teamName}
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl text-gradient-gold anim-neon tracking-wider">
            {gameName}
          </h1>
        </div>

        {/* 遊戲規則 */}
        <div className="pixel-panel p-5 mb-4">
          <h2 className="text-xl text-gradient-cyan tracking-widest mb-3 flex items-center gap-2">
            <PxIcon name="shield" size={22} /> 遊戲規則
          </h2>
          <ul className="space-y-2 text-lg text-[#8899bb]">
            <li className="flex items-start gap-2">
              <span className="text-gradient-gold shrink-0">▸</span>
              <span>{PLAYERS.length} 位選手輪流抽卡</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-gradient-gold shrink-0">▸</span>
              <span>共 {TOTAL_ROUNDS} 回合，每回合每人抽 1 張</span>
            </li>
          </ul>
        </div>

        {/* 卡片說明 */}
        <div className="pixel-panel p-5 mb-6">
          <h2 className="text-xl text-gradient-cyan tracking-widest mb-3 flex items-center gap-2">
            <PxIcon name="crown" size={22} /> 卡片說明
          </h2>
          <div className="space-y-2.5 text-lg">
            {/* Money cards */}
            <div className="flex items-center gap-3 flex-wrap">
              <PxIcon name="coin" size={22} />
              {moneyTiers.map((t, i) => (
                <span key={i} className="flex items-center gap-1">
                  {i > 0 && <span className="text-[#334]">│</span>}
                  <span className="text-gradient-gold">
                    {"$" + t.value.toLocaleString()}
                  </span>
                  <span className="text-[#556]">×{t.count}</span>
                </span>
              ))}
            </div>
            {/* Nothing */}
            <div className="flex items-center gap-3">
              <PxIcon name="skull" size={22} />
              <span className="text-[#556]">銘謝惠顧</span>
              <span className="text-[#445]">×{nothingCount}</span>
            </div>
            {/* Divider */}
            <div className="border-t border-[#223] my-1"></div>
            {/* Props */}
            <div className="flex items-center gap-3">
              <PxIcon name="swap" size={22} />
              <span className="text-gradient-purple">交換卡</span>
              <span className="text-[#556]">×2</span>
              <span className="text-[#445]">— 與下位選手交換結果</span>
            </div>
            <div className="flex items-center gap-3">
              <PxIcon name="eye" size={22} />
              <span className="text-gradient-cyan">偷看卡</span>
              <span className="text-[#556]">×2</span>
              <span className="text-[#445]">— 先偷看一張再決定</span>
            </div>
            <div className="flex items-center gap-3">
              <PxIcon name="bolt" size={22} />
              <span className="text-gradient-gold">雙倍卡</span>
              <span className="text-[#556]">×2</span>
              <span className="text-[#445]">— 下次獎金翻倍</span>
            </div>
            {/* Note */}
            <p className="text-base text-[#667] mt-2 flex items-start gap-2">
              <span className="text-gradient-green shrink-0">※</span>
              道具卡不消耗回合，抽到後可再抽一張
            </p>
          </div>
        </div>

        {/* START Button */}
        <div className="text-center">
          <button
            onClick={() => {
              sfxCtaClick();
              onStart();
            }}
            onMouseEnter={sfxHover}
            className="px-12 py-4 pixel-btn-gold text-2xl sm:text-3xl tracking-widest anim-neon
                       flex items-center gap-3 mx-auto"
          >
            <PxIcon name="star" size={28} />
            開始遊戲
            <PxIcon name="star" size={28} />
          </button>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════ ConfigScreen ═══════════════════ */
function ConfigScreen({ teamName, gameName, defaultTiers, onConfirm }) {
  const [team, setTeam] = useState(teamName);
  const [game, setGame] = useState(gameName);
  const [tiers, setTiers] = useState(() => defaultTiers.map((t) => ({ ...t })));

  const handleTier = (idx, field, raw) => {
    setTiers((prev) => {
      const u = [...prev];
      u[idx] = { ...u[idx], [field]: raw === "" ? "" : Math.max(0, parseInt(raw) || 0) };
      return u;
    });
  };

  const moneyTotal = tiers.reduce((s, t) => s + (parseInt(t.count) || 0), 0);
  const nothingCount = TOTAL_CARDS - moneyTotal - PROP_TOTAL;
  const totalPrize = tiers.reduce(
    (s, t) => s + (parseInt(t.value) || 0) * (parseInt(t.count) || 0),
    0
  );
  const namesFilled = team.trim().length > 0 && game.trim().length > 0;
  const valid = namesFilled && nothingCount >= 0 && moneyTotal > 0;

  return (
    <div
      className="h-screen flex flex-col items-center overflow-y-auto
                    bg-pixel text-white scanlines p-4"
    >
      <div
        className="max-w-3xl w-full my-auto anim-scale"
        style={{ position: "relative", zIndex: 1 }}
      >
        <div className="text-center mb-6">
          <h1 className="text-4xl sm:text-5xl text-gradient-gold tracking-wider">
            遊戲設定
          </h1>
        </div>

        {/* Team & Game Name */}
        <div className="pixel-panel p-5 sm:p-6 mb-4 space-y-4">
          <div className="flex items-center justify-center gap-4">
            <span className="text-xl sm:text-2xl text-gradient-cyan shrink-0">
              團隊名稱
            </span>
            <input
              type="text"
              value={team}
              onChange={(e) => setTeam(e.target.value)}
              maxLength={12}
              className="flex-1 max-w-sm px-3 py-2 text-2xl sm:text-3xl text-white text-center
                         bg-[#0a0a25] border-2 border-[#0088cc]
                         focus:border-[#00ccff] focus:outline-none
                         placeholder-[#334]"
              style={{ fontFamily: "inherit" }}
              placeholder="Finfo"
            />
          </div>
          <div className="flex items-center justify-center gap-4">
            <span className="text-xl sm:text-2xl text-gradient-cyan shrink-0">
              遊戲名稱
            </span>
            <input
              type="text"
              value={game}
              onChange={(e) => setGame(e.target.value)}
              maxLength={12}
              className="flex-1 max-w-sm px-3 py-2 text-2xl sm:text-3xl text-white text-center
                         bg-[#0a0a25] border-2 border-[#0088cc]
                         focus:border-[#00ccff] focus:outline-none
                         placeholder-[#334]"
              style={{ fontFamily: "inherit" }}
              placeholder="尾牙一番賞"
            />
          </div>
        </div>

        {/* Prize Tiers */}
        <div className="pixel-panel p-5 sm:p-6 mb-4">
          <h2 className="text-xl sm:text-2xl text-gradient-cyan tracking-widest mb-4 flex items-center gap-2 justify-center">
            <PxIcon name="coin" size={22} /> 獎金設定
          </h2>
          <div className="space-y-3">
            {tiers.map((t, i) => (
              <div key={i} className="flex items-center justify-center gap-3">
                <span className="text-xl sm:text-2xl text-gradient-gold shrink-0">$</span>
                <input
                  type="number"
                  value={t.value}
                  onChange={(e) => handleTier(i, "value", e.target.value)}
                  min={0}
                  className="w-28 sm:w-32 px-2 py-1.5 text-xl sm:text-2xl text-white text-center
                             bg-[#0a0a25] border-2 border-[#0088cc]
                             focus:border-[#00ccff] focus:outline-none"
                  style={{ fontFamily: "inherit" }}
                />
                <span className="text-xl sm:text-2xl text-[#556]">×</span>
                <input
                  type="number"
                  value={t.count}
                  onChange={(e) => handleTier(i, "count", e.target.value)}
                  min={0}
                  className="w-16 sm:w-20 px-2 py-1.5 text-xl sm:text-2xl text-white text-center
                             bg-[#0a0a25] border-2 border-[#0088cc]
                             focus:border-[#00ccff] focus:outline-none"
                  style={{ fontFamily: "inherit" }}
                />
              </div>
            ))}
          </div>

          {/* Summary */}
          <div className="border-t border-[#223] mt-4 pt-4 space-y-1.5 text-center">
            <div className="flex items-center justify-center gap-6 text-lg sm:text-xl">
              <span>
                <PxIcon name="skull" size={18} />{" "}
                <span className="text-[#556]">銘謝惠顧</span>{" "}
                <span className={nothingCount < 0 ? "text-gradient-red" : "text-[#8899bb]"}>
                  ×{nothingCount}
                </span>
                <span className="text-[#334] text-base"> (自動)</span>
              </span>
              <span>
                <span className="text-[#556]">道具卡</span>{" "}
                <span className="text-[#8899bb]">×{PROP_TOTAL}</span>
              </span>
            </div>
            <div className="flex items-center justify-center gap-6 text-lg sm:text-xl">
              <span>
                總獎金{" "}
                <span className="text-gradient-green">{fmt(totalPrize)}</span>
              </span>
              <span>
                總卡片{" "}
                <span className="text-[#8899bb]">{TOTAL_CARDS}</span>
              </span>
            </div>
            {nothingCount < 0 && (
              <p className="text-gradient-red text-base anim-blink">
                卡片數量超過 {TOTAL_CARDS} 張！請減少獎金卡數量
              </p>
            )}
          </div>
        </div>

        <div className="text-center">
          <button
            onClick={() => {
              sfxCtaClick();
              if (valid) {
                const cleaned = tiers
                  .filter((t) => (parseInt(t.count) || 0) > 0 && (parseInt(t.value) || 0) > 0)
                  .map((t) => ({ value: parseInt(t.value), count: parseInt(t.count) }));
                onConfirm(team.trim(), game.trim(), cleaned);
              }
            }}
            onMouseEnter={sfxHover}
            disabled={!valid}
            className="px-12 py-4 pixel-btn-gold text-2xl sm:text-3xl tracking-widest anim-neon
                       flex items-center gap-3 mx-auto
                       disabled:opacity-30 disabled:pointer-events-none"
          >
            <PxIcon name="star" size={28} />
            確認
            <PxIcon name="star" size={28} />
          </button>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════ SetupScreen ═══════════════════ */
function SetupScreen({ defaultNames, onConfirm }) {
  const [names, setNames] = useState(() => defaultNames.map((n) => n));
  const allFilled = names.every((n) => n.trim().length > 0);

  const handleChange = (idx, val) => {
    setNames((prev) => {
      const u = [...prev];
      u[idx] = val;
      return u;
    });
  };

  return (
    <div
      className="h-screen flex flex-col items-center justify-center
                    bg-pixel text-white scanlines p-4"
    >
      <div
        className="max-w-5xl w-full anim-scale"
        style={{ position: "relative", zIndex: 1 }}
      >
        <div className="text-center mb-10">
          <h1 className="text-4xl sm:text-5xl text-gradient-gold tracking-wider">
            設定選手暱稱
          </h1>
        </div>

        <div className="pixel-panel p-5 sm:p-6 mb-10">
          <div className="grid grid-cols-3 gap-3 sm:gap-4">
            {names.map((name, i) => (
              <div key={i} className="flex flex-col items-center gap-1">
                <span className="text-xl sm:text-2xl text-gradient-cyan">
                  {i + 1}.
                </span>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => handleChange(i, e.target.value)}
                  maxLength={10}
                  className="w-full px-3 py-2.5 text-2xl sm:text-3xl text-white text-center
                             bg-[#0a0a25] border-2 border-[#0088cc]
                             focus:border-[#00ccff] focus:outline-none
                             placeholder-[#334]"
                  style={{ fontFamily: "inherit" }}
                  placeholder={`選手 ${i + 1}`}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <button
            onClick={() => {
              sfxCtaClick();
              allFilled && onConfirm(names.map((n) => n.trim()));
            }}
            onMouseEnter={sfxHover}
            disabled={!allFilled}
            className="px-12 py-4 pixel-btn-gold text-2xl sm:text-3xl tracking-widest anim-neon
                       flex items-center gap-3 mx-auto
                       disabled:opacity-30 disabled:pointer-events-none"
          >
            <PxIcon name="star" size={28} />
            確認開始
            <PxIcon name="star" size={28} />
          </button>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════ Main App ═══════════════════ */
function App() {
  const [cards, setCards] = useState(() => generateDeck());
  const [players, setPlayers] = useState(() => initPlayers());
  const [currentPlayerIdx, setCurrentPlayerIdx] = useState(0);
  const [round, setRound] = useState(1);
  const [gameOver, setGameOver] = useState(false);
  const [activeProp, setActiveProp] = useState(null);
  const [peekingCardId, setPeekingCardId] = useState(null);
  const [peekCard, setPeekCard] = useState(null);
  const [showPeekConfirm, setShowPeekConfirm] = useState(false);
  const [resultModal, setResultModal] = useState(null);
  const [, setFlippingId] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [roundTransition, setRoundTransition] = useState(false);
  const [pendingSwap, setPendingSwap] = useState(null);
  const [showSwapOffer, setShowSwapOffer] = useState(false);
  const [swapOfferInfo, setSwapOfferInfo] = useState(null);
  const [swapExecuteResult, setSwapExecuteResult] = useState(null);
  const [awaitingTurnStart, setAwaitingTurnStart] = useState(true);
  const [showRanking, setShowRanking] = useState(false);
  const [quizModal, setQuizModal] = useState(null);
  const [gamePhase, setGamePhase] = useState("welcome");
  const [bgmMuted, setBgmMuted] = useState(false);
  const [teamName, setTeamName] = useState("Finfo");
  const [gameName, setGameName] = useState("尾牙一番賞");
  const [moneyTiers, setMoneyTiers] = useState(DEFAULT_MONEY_TIERS);

  const bgmStartRef = useRef(null);
  const timerRef = useRef(null);
  const playersRef = useRef(players);
  const roundRef = useRef(round);
  const currentPlayerIdxRef = useRef(currentPlayerIdx);
  const pendingSwapRef = useRef(pendingSwap);
  const moneyTiersRef = useRef(moneyTiers);
  playersRef.current = players;
  moneyTiersRef.current = moneyTiers;
  roundRef.current = round;
  currentPlayerIdxRef.current = currentPlayerIdx;
  pendingSwapRef.current = pendingSwap;

  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    },
    []
  );

  /* ── BGM ── */
  useEffect(() => {
    if (!bgmStartRef.current) {
      const a = new Audio("/bgm_dst_tower_defense_theme.mp3");
      a.loop = true;
      a.volume = 0.7;
      bgmStartRef.current = a;
    }
    const audio = bgmStartRef.current;

    if (bgmMuted) {
      audio.pause();
      return;
    }

    if (gamePhase === "config" || gamePhase === "start" || gamePhase === "setup" || gamePhase === "playing") {
      if (audio.paused) {
        audio.volume = 0.7;
        audio.play().catch(() => {});
      }
    } else {
      audio.pause();
      audio.currentTime = 0;
    }
  }, [gamePhase, bgmMuted]);

  const cur = players[currentPlayerIdx];

  const findNextIdx = useCallback(() => {
    const ps = playersRef.current;
    const idx = currentPlayerIdxRef.current;
    let next = (idx + 1) % PLAYERS.length;
    let safety = 0;
    while (ps[next].roundFlipped && safety < PLAYERS.length) {
      next = (next + 1) % PLAYERS.length;
      safety++;
    }
    return ps[next].roundFlipped ? -1 : next;
  }, []);

  /* ── 5. goToTurnTransition ── */
  const goToTurnTransition = useCallback(() => {
    const ps = playersRef.current;
    const r = roundRef.current;

    if (ps.every((p) => p.roundFlipped)) {
      if (r >= TOTAL_ROUNDS) {
        setGameOver(true);
        setIsProcessing(false);
        setTimeout(() => playSfx("sound_winneris.ogg"), 300);
        return;
      }
      setRoundTransition(true);
      setIsProcessing(false);
      setTimeout(() => playSfx("sound_end_turn.wav"), 300);
      return;
    }

    const next = findNextIdx();
    setCurrentPlayerIdx(next);
    setAwaitingTurnStart(true);
    setIsProcessing(false);
  }, [findNextIdx]);

  /* ── 4. checkSwapOffer ── */
  const checkSwapOffer = useCallback(() => {
    const ps = playersRef.current;
    const curIdx = currentPlayerIdxRef.current;
    const curPlayer = ps[curIdx];

    if (curPlayer.props.includes("swap")) {
      const allFlipped = ps.every((p) => p.roundFlipped);

      if (allFlipped) {
        /* Last player of the round — swap with first player of next round */
        const r = roundRef.current;
        if (r < TOTAL_ROUNDS) {
          setSwapOfferInfo({
            playerName: curPlayer.name,
            value: curPlayer.lastFlippedValue,
            nextName: ps[0].name,
          });
          setShowSwapOffer(true);
          return;
        }
        /* Last round — no one left to swap with */
      } else {
        let next = (curIdx + 1) % PLAYERS.length;
        let safety = 0;
        while (ps[next].roundFlipped && safety < PLAYERS.length) {
          next = (next + 1) % PLAYERS.length;
          safety++;
        }
        if (!ps[next].roundFlipped) {
          setSwapOfferInfo({
            playerName: curPlayer.name,
            value: curPlayer.lastFlippedValue,
            nextName: ps[next].name,
          });
          setShowSwapOffer(true);
          return;
        }
      }
    }

    goToTurnTransition();
  }, [goToTurnTransition]);

  /* ── 3. resolveAfterResult ── */
  const resolveAfterResult = useCallback(() => {
    setResultModal(null);

    const curIdx = currentPlayerIdxRef.current;
    const curPlayer = playersRef.current[curIdx];

    /* Pending swap from previous player — execute immediately regardless of card type */
    const swap = pendingSwapRef.current;
    if (swap) {
      const ps = playersRef.current;
      const fromName = ps[swap.fromId].name;
      const toName = ps[curIdx].name;
      const fromVal = swap.fromValue;

      if (!curPlayer.roundFlipped) {
        /* Player B drew a prop card — prop goes to Player A, money goes to Player B */
        const PROP_LABELS = { peek: "偷看卡", swap: "交換卡", double: "雙倍卡" };
        const drawnProp = curPlayer.props[curPlayer.props.length - 1];
        const propLabel = PROP_LABELS[drawnProp] || drawnProp;

        setPlayers((prev) => {
          const u = [...prev];
          const fp = { ...u[swap.fromId] };
          fp.totalMoney -= fromVal;
          fp.lastFlippedValue = 0;
          fp.props = [...fp.props, drawnProp];
          u[swap.fromId] = fp;
          const cp = { ...u[curIdx] };
          cp.totalMoney += fromVal;
          cp.lastFlippedValue = fromVal;
          cp.props = cp.props.slice(0, -1);
          /* roundFlipped stays false — Player B still needs to draw again */
          u[curIdx] = cp;
          return u;
        });

        setPendingSwap(null);
        setSwapExecuteResult({
          fromName,
          toName,
          fromGets: propLabel,
          toGets: fromVal,
        });
        return;
      }

      /* Player B drew money/nothing — swap money values */
      const toVal = curPlayer.lastFlippedValue;

      setPlayers((prev) => {
        const u = [...prev];
        const fp = { ...u[swap.fromId] };
        fp.totalMoney = fp.totalMoney - fromVal + toVal;
        fp.lastFlippedValue = toVal;
        u[swap.fromId] = fp;
        const cp = { ...u[curIdx] };
        cp.totalMoney = cp.totalMoney - toVal + fromVal;
        cp.lastFlippedValue = fromVal;
        u[curIdx] = cp;
        return u;
      });

      setPendingSwap(null);
      setSwapExecuteResult({
        fromName,
        toName,
        fromGets: toVal,
        toGets: fromVal,
      });
      return;
    }

    /* Prop card: player draws again (not roundFlipped) */
    if (!curPlayer.roundFlipped) {
      setIsProcessing(false);
      return;
    }

    checkSwapOffer();
  }, [checkSwapOffer]);

  /* ── 2. dismissResult (manual confirm) ── */
  const dismissResult = useCallback(() => {
    resolveAfterResult();
  }, [resolveAfterResult]);

  const dismissSwapResult = useCallback(() => {
    setSwapExecuteResult(null);
    const curPlayer = playersRef.current[currentPlayerIdxRef.current];
    if (!curPlayer.roundFlipped) {
      /* Player drew a prop card and got swapped — still needs to draw again */
      setIsProcessing(false);
      return;
    }
    checkSwapOffer();
  }, [checkSwapOffer]);

  /* ── 1. processFlip ── */
  const processFlip = useCallback((cardId, card, forceDouble) => {
    const pidx = currentPlayerIdxRef.current;
    const dbl = forceDouble || playersRef.current[pidx].doubleActive;

    setFlippingId(cardId);
    setCards((prev) =>
      prev.map((c) =>
        c.id === cardId ? { ...c, flipped: true, flippedBy: pidx } : c
      )
    );

    setTimeout(() => {
      setFlippingId(null);

      if (card.type === "prop") {
        /* Prop card: does NOT consume round — player draws again */
        setPlayers((prev) => {
          const u = [...prev];
          const p = { ...u[pidx] };
          p.props = [...p.props, card.prop];
          /* roundFlipped stays false */
          u[pidx] = p;
          return u;
        });
        const desc =
          card.prop === "peek"
            ? "偷看一格再決定"
            : card.prop === "double"
            ? "下次抽卡獎金×2"
            : "可與下位選手交換結果";
        setResultModal({
          icon: card.icon,
          label: `獲得 ${card.label}！`,
          extra: `${desc} — 再抽一張！`,
        });
        setTimeout(() => playSfx("sound_coin.wav"), 300);
      } else if (card.type === "money") {
        /* Quiz card: show quiz modal instead of immediate result */
        if (card.quiz) {
          setQuizModal({
            ...card.quiz,
            cardId,
            card,
            dbl,
            pidx,
          });
          return;
        }
        let val = card.value,
          extra = "";
        if (dbl) {
          val *= 2;
          extra = " (×2)";
        }
        setPlayers((prev) => {
          const u = [...prev];
          const p = { ...u[pidx] };
          p.totalMoney += val;
          p.roundFlipped = true;
          p.lastFlippedValue = val;
          p.lastFlippedCardId = cardId;
          if (dbl) p.doubleActive = false;
          u[pidx] = p;
          return u;
        });
        const pName = playersRef.current[pidx].name;
        setResultModal({
          icon: dbl ? "bolt" : "coin",
          label: fmt(val),
          extra: `${pName} 中獎！${extra}`,
        });
        const maxTierValue = Math.max(...moneyTiersRef.current.map((t) => t.value));
        setTimeout(() => playSfx(card.value === maxTierValue ? "sound_first_prize.ogg" : "sound_coin.wav"), 300);
      } else {
        setPlayers((prev) => {
          const u = [...prev];
          const p = { ...u[pidx] };
          p.roundFlipped = true;
          p.lastFlippedValue = 0;
          if (dbl) p.doubleActive = false;
          u[pidx] = p;
          return u;
        });
        setResultModal({
          icon: "skull",
          label: "銘謝惠顧",
          extra: dbl ? "0 × 2 = 0 再接再厲…" : "再接再厲…",
        });
        setTimeout(() => playSfx("sound_fail.wav"), 300);
      }
    }, 500);
  }, []);

  /* ── handleQuizAnswer ── */
  const handleQuizAnswer = useCallback((chosenIndex) => {
    if (!quizModal) return;
    const { correctIndex, dbl, pidx, cardId } = quizModal;
    const correct = chosenIndex === correctIndex;
    const baseValue = correct ? 1000 * 2 : 1000;
    const finalValue = dbl ? baseValue * 2 : baseValue;

    setPlayers((prev) => {
      const u = [...prev];
      const p = { ...u[pidx] };
      p.totalMoney += finalValue;
      p.roundFlipped = true;
      p.lastFlippedValue = finalValue;
      p.lastFlippedCardId = cardId;
      if (dbl) p.doubleActive = false;
      u[pidx] = p;
      return u;
    });

    const pName = playersRef.current[pidx].name;
    const dblLabel = dbl ? " (×2)" : "";
    if (correct) {
      setResultModal({
        icon: "bolt",
        label: fmt(finalValue),
        extra: `${pName} 答對了！獎金翻倍！${dblLabel}`,
      });
      setTimeout(() => playSfx("sound_first_prize.ogg"), 300);
    } else {
      setResultModal({
        icon: "coin",
        label: fmt(finalValue),
        extra: `${pName} 答錯了！${dblLabel}`,
      });
      setTimeout(() => playSfx("sound_coin.wav"), 300);
    }
    setQuizModal(null);
  }, [quizModal]);

  /* ── card click ── */
  const handleCardClick = useCallback(
    (cardId) => {
      if (isProcessing || gameOver || roundTransition || awaitingTurnStart)
        return;
      if (players[currentPlayerIdx].roundFlipped) return;
      const card = cards.find((c) => c.id === cardId);
      if (!card || card.flipped) return;

      if (activeProp === "peek") {
        setPlayers((prev) => {
          const u = [...prev];
          const p = { ...u[currentPlayerIdx] };
          const i = p.props.indexOf("peek");
          if (i >= 0) {
            p.props = [...p.props];
            p.props.splice(i, 1);
          }
          u[currentPlayerIdx] = p;
          return u;
        });
        setPeekingCardId(cardId);
        setPeekCard(card);
        setShowPeekConfirm(true);
        return;
      }

      const useDouble = activeProp === "double";
      if (useDouble) {
        setPlayers((prev) => {
          const u = [...prev];
          const p = { ...u[currentPlayerIdx] };
          const i = p.props.indexOf("double");
          if (i >= 0) {
            p.props = [...p.props];
            p.props.splice(i, 1);
          }
          p.doubleActive = true;
          u[currentPlayerIdx] = p;
          return u;
        });
        setActiveProp(null);
      }

      setIsProcessing(true);
      processFlip(cardId, card, useDouble);
    },
    [
      isProcessing,
      gameOver,
      roundTransition,
      awaitingTurnStart,
      players,
      currentPlayerIdx,
      cards,
      activeProp,
      processFlip,
    ]
  );

  const handlePeekConfirm = useCallback(() => {
    setShowPeekConfirm(false);
    setActiveProp(null);
    if (peekCard) {
      setIsProcessing(true);
      processFlip(peekCard.id, peekCard);
    }
    setPeekingCardId(null);
    setPeekCard(null);
  }, [peekCard, processFlip]);

  const handlePeekCancel = useCallback(() => {
    setShowPeekConfirm(false);
    setPeekingCardId(null);
    setPeekCard(null);
    setActiveProp(null);
  }, []);

  const handleUseProp = useCallback(
    (key) => {
      if (isProcessing || awaitingTurnStart) return;
      if (key === "swap") return;
      if (activeProp === key) {
        setActiveProp(null);
        setPeekingCardId(null);
        return;
      }
      setActiveProp(key);
    },
    [isProcessing, awaitingTurnStart, activeProp]
  );

  const handleSwapOfferAccept = useCallback(() => {
    const curIdx = currentPlayerIdxRef.current;
    const curPlayer = playersRef.current[curIdx];
    setPlayers((prev) => {
      const u = [...prev];
      const p = { ...u[curIdx] };
      const i = p.props.indexOf("swap");
      if (i >= 0) {
        p.props = [...p.props];
        p.props.splice(i, 1);
      }
      u[curIdx] = p;
      return u;
    });
    setPendingSwap({ fromId: curIdx, fromValue: curPlayer.lastFlippedValue });
    setShowSwapOffer(false);
    setSwapOfferInfo(null);
    goToTurnTransition();
  }, [goToTurnTransition]);

  const handleSwapOfferDecline = useCallback(() => {
    setShowSwapOffer(false);
    setSwapOfferInfo(null);
    goToTurnTransition();
  }, [goToTurnTransition]);

  const handleTurnStartConfirm = useCallback(() => {
    setAwaitingTurnStart(false);
    setActiveProp(null);
  }, []);

  const handleRoundTransitionConfirm = useCallback(() => {
    setPlayers((prev) =>
      prev.map((p) => ({
        ...p,
        roundFlipped: false,
        lastFlippedValue: 0,
        lastFlippedCardId: null,
      }))
    );
    setRound((rr) => rr + 1);
    setCurrentPlayerIdx(0);
    setRoundTransition(false);
    setAwaitingTurnStart(true);
  }, []);

  const handleRestart = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setCards(generateDeck(moneyTiers));
    setPlayers(initPlayers());
    setCurrentPlayerIdx(0);
    setRound(1);
    setGameOver(false);
    setActiveProp(null);
    setPeekingCardId(null);
    setPeekCard(null);
    setShowPeekConfirm(false);
    setResultModal(null);
    setFlippingId(null);
    setIsProcessing(false);
    setRoundTransition(false);
    setPendingSwap(null);
    setShowSwapOffer(false);
    setSwapOfferInfo(null);
    setSwapExecuteResult(null);
    setAwaitingTurnStart(true);
    setShowRanking(false);
    setQuizModal(null);
    setGamePhase("start");
  }, [moneyTiers]);

  /* ── derived ── */
  const totalPrize = moneyTiers.reduce((s, t) => s + t.value * t.count, 0);
  const remaining = TOTAL_CARDS - cards.filter((c) => c.flipped).length;
  const propCounts = {};
  cur.props.forEach((p) => {
    propCounts[p] = (propCounts[p] || 0) + 1;
  });
  const propEntries = Object.entries(propCounts);
  const propMeta = {
    peek: { name: "偷看", desc: "偷看一張再決定" },
    double: { name: "雙倍", desc: "獎金×2" },
    swap: { name: "交換", desc: "與下位交換結果" },
  };
  const ranked = [...players].sort((a, b) => b.totalMoney - a.totalMoney);

  /* ═══════════════════ RENDER ═══════════════════ */
  const muteBtn = (
    <button
      onClick={() => setBgmMuted((m) => !m)}
      className="fixed bottom-4 left-4 z-50 pixel-btn p-3"
      style={{ lineHeight: 1 }}
      aria-label={bgmMuted ? "取消靜音" : "靜音"}
    >
      {bgmMuted ? (
        <svg
          viewBox="0 0 10 8"
          width={28}
          height={22}
          style={{ imageRendering: "pixelated", display: "block" }}
        >
          <rect x="0" y="2" width="2" height="4" fill="#ff4444" />
          <rect x="2" y="1" width="1" height="6" fill="#ff4444" />
          <rect x="3" y="0" width="1" height="8" fill="#ff4444" />
          <rect x="6" y="1" width="1" height="1" fill="#ff4444" />
          <rect x="8" y="1" width="1" height="1" fill="#ff4444" />
          <rect x="7" y="2" width="1" height="1" fill="#ff4444" />
          <rect x="7" y="5" width="1" height="1" fill="#ff4444" />
          <rect x="6" y="6" width="1" height="1" fill="#ff4444" />
          <rect x="8" y="6" width="1" height="1" fill="#ff4444" />
        </svg>
      ) : (
        <svg
          viewBox="0 0 10 8"
          width={28}
          height={22}
          style={{ imageRendering: "pixelated", display: "block" }}
        >
          <rect x="0" y="2" width="2" height="4" fill="#00eeff" />
          <rect x="2" y="1" width="1" height="6" fill="#00eeff" />
          <rect x="3" y="0" width="1" height="8" fill="#00eeff" />
          <rect x="6" y="2" width="1" height="1" fill="#00eeff" />
          <rect x="6" y="5" width="1" height="1" fill="#00eeff" />
          <rect x="7" y="1" width="1" height="2" fill="#00eeff" />
          <rect x="7" y="5" width="1" height="2" fill="#00eeff" />
          <rect x="8" y="0" width="1" height="3" fill="#00eeff" />
          <rect x="8" y="5" width="1" height="3" fill="#00eeff" />
        </svg>
      )}
    </button>
  );

  if (gamePhase === "welcome") {
    return (
      <div
        className="h-screen flex flex-col items-center justify-center bg-pixel text-white scanlines cursor-pointer"
        onClick={() => setGamePhase("config")}
      >
        <div
          className="anim-scale text-center"
          style={{ position: "relative", zIndex: 1 }}
        >
          <p className="text-3xl sm:text-4xl text-gradient-cyan anim-blink tracking-widest">
            CLICK TO START
          </p>
        </div>
      </div>
    );
  }
  if (gamePhase === "config") {
    return (
      <>
        <ConfigScreen
          teamName={teamName}
          gameName={gameName}
          defaultTiers={moneyTiers}
          onConfirm={(t, g, tiers) => {
            setTeamName(t);
            setGameName(g);
            setMoneyTiers(tiers);
            setGamePhase("start");
          }}
        />
        {muteBtn}
      </>
    );
  }
  if (gamePhase === "start") {
    return (
      <>
        <StartScreen onStart={() => setGamePhase("setup")} teamName={teamName} gameName={gameName} moneyTiers={moneyTiers} />
        {muteBtn}
      </>
    );
  }
  if (gamePhase === "setup") {
    return (
      <>
        <SetupScreen
          defaultNames={PLAYERS}
          onConfirm={(names) => {
            setPlayers(initPlayers(names));
            setCards(generateDeck(moneyTiers));
            setGamePhase("playing");
          }}
        />
        {muteBtn}
      </>
    );
  }

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-pixel text-white scanlines">
      {/* ── Header ── */}
      <header className="shrink-0 pixel-panel-header px-4 sm:px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            onClick={() => setShowRanking((v) => !v)}
            className="pixel-btn p-2 text-[#00eeff]"
            aria-label="排行榜"
          >
            <PxIcon name="menu" size={24} />
          </button>
          <h1 className="text-xl sm:text-3xl text-gradient-gold tracking-wider flex items-center gap-2 sm:gap-3">
            <PxIcon name="star" size={28} /> {gameName}
          </h1>
        </div>
        <div className="flex items-center gap-3 sm:gap-8 text-lg sm:text-xl">
          <span className="text-gradient-cyan">
            獎池 <span className="text-gradient-green">{fmt(totalPrize)}</span>
          </span>
          <span className="text-gradient-cyan">
            剩餘 <span className="text-gradient-red">{remaining}</span>
          </span>
        </div>
      </header>

      {/* ── Body (full width, no sidebar) ── */}
      <div className="flex-1 flex flex-col gap-2 p-2 min-h-0">
        {/* info bar */}
        <div className="shrink-0 pixel-panel px-5 py-3">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div className="flex items-center gap-4">
              <span className="text-xl text-[#06061a] bg-[#ffcc00] px-3 py-1 font-bold">
                回合 {round}/{TOTAL_ROUNDS}
              </span>
              <span className="text-xl sm:text-2xl text-gradient-gold flex items-center gap-2">
                <PxIcon name="arrowR" size={22} /> {cur.name}
                <span className="text-gradient-green">{fmt(cur.totalMoney)}</span>
              </span>
            </div>
            <div className="flex items-center gap-4">
              {(cur.doubleActive || activeProp === "double") && (
                <span className="text-xl text-gradient-gold anim-blink flex items-center gap-1">
                  <PxIcon name="bolt" size={20} /> ×2 啟動
                </span>
              )}
              {activeProp === "peek" && (
                <span className="text-xl text-gradient-green anim-blink flex items-center gap-1">
                  <PxIcon name="eye" size={20} /> 偷看模式
                </span>
              )}
            </div>
          </div>
          {/* props row */}
          <div className="flex items-center justify-center gap-4 mt-2 min-h-[40px]">
            {propEntries.length === 0 && !cur.doubleActive ? (
              <span className="text-xl text-[#334]">無道具</span>
            ) : (
              <>
                {propEntries.map(([key, cnt]) => {
                  if (key === "swap") {
                    return (
                      <span
                        key={key}
                        className="flex items-center gap-2 px-4 py-1.5 text-xl
                                                  pixel-panel opacity-70"
                        style={{ borderColor: "#cc44ff" }}
                      >
                        <PxIcon name={PROP_ICON_MAP[key]} size={22} />
                        <span className="text-gradient-purple">
                          {propMeta[key].name}
                        </span>
                        <span className="text-base opacity-60">×{cnt}</span>
                        <span className="text-[#334]">—</span>
                        <span className="text-base text-[#8899bb]">
                          {propMeta[key].desc}
                        </span>
                        <span className="text-sm text-[#667]">(自動)</span>
                      </span>
                    );
                  }
                  const active = activeProp === key;
                  return (
                    <button
                      key={key}
                      onClick={() => {
                        playSfx("sound_card_effect.wav");
                        handleUseProp(key);
                      }}
                      onMouseEnter={() => playSfx("sound_card_hover.wav")}
                      disabled={
                        isProcessing || cur.roundFlipped || awaitingTurnStart ||
                        (key === "double" && cur.doubleActive)
                      }
                      className={`flex items-center gap-2 px-4 py-1.5 text-xl
                        ${active ? "pixel-btn-gold" : "pixel-btn"}
                        disabled:opacity-30 disabled:pointer-events-none`}
                    >
                      <PxIcon name={PROP_ICON_MAP[key]} size={22} />
                      <span>{propMeta[key].name}</span>
                      <span className="text-base opacity-60">×{cnt}</span>
                      <span className="text-[#334]">—</span>
                      <span className="text-base text-[#8899bb]">
                        {propMeta[key].desc}
                      </span>
                    </button>
                  );
                })}
              </>
            )}
          </div>
        </div>

        {/* ── Card Grid 10×6 ── */}
        <div className="flex-1 min-h-0 pixel-panel p-1.5 sm:p-2">
          <div className="grid grid-cols-10 grid-rows-6 gap-[2px] sm:gap-1 h-full">
            {cards.map((card) => (
              <GameCard
                key={card.id}
                card={card}
                onClick={handleCardClick}
                peekingId={peekingCardId}
              />
            ))}
          </div>
        </div>
      </div>

      {/* ── Slide-out Ranking Drawer ── */}
      {showRanking && (
        <div
          className="fixed inset-0 z-20 bg-black/60"
          onClick={() => setShowRanking(false)}
        />
      )}
      <aside
        className={`fixed inset-y-0 left-0 z-30 w-80 pixel-panel p-4
                         overflow-y-auto scrollbar-pixel slide-panel
                         ${showRanking ? "slide-panel-open" : ""}`}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl text-gradient-cyan tracking-widest">排行榜</h2>
          <button
            onClick={() => setShowRanking(false)}
            className="pixel-btn p-1.5 text-[#ff6666]"
          >
            <PxIcon name="close" size={20} />
          </button>
        </div>
        <div className="space-y-1.5">
          {ranked.map((p, rank) => {
            const isCur = p.id === currentPlayerIdx;
            return (
              <div
                key={p.id}
                className={`flex items-center justify-between px-3 py-2 text-lg
                  ${isCur ? "pixel-panel-gold" : "hover:bg-white/[0.04]"}`}
              >
                <div className="flex items-center gap-2 min-w-0">
                  {isCur && (
                    <span className="anim-blink">
                      <PxIcon name="arrowR" size={16} />
                    </span>
                  )}
                  <span className="w-8 flex justify-center shrink-0">
                    {rank === 0 ? (
                      <PxIcon name="crown" size={20} />
                    ) : rank === 1 ? (
                      <span className="text-[#aabbcc]">#2</span>
                    ) : rank === 2 ? (
                      <span className="text-[#cc8844]">#3</span>
                    ) : (
                      <span className="text-[#445]">{rank + 1}</span>
                    )}
                  </span>
                  <span
                    className={`truncate ${
                      isCur ? "text-gradient-gold" : "text-[#8899bb]"
                    }`}
                  >
                    {p.name}
                  </span>
                </div>
                <div className="flex items-center gap-2 shrink-0 ml-1">
                  {p.props.length > 0 && (
                    <span className="flex gap-0.5">
                      {p.props.map((pr, i) => (
                        <PxIcon key={i} name={PROP_ICON_MAP[pr]} size={16} />
                      ))}
                    </span>
                  )}
                  {p.doubleActive && (
                    <span className="text-[#ffcc00] text-sm">×2</span>
                  )}
                  <span
                    className={`${
                      p.totalMoney > 0 ? "text-gradient-green" : "text-[#334]"
                    }`}
                  >
                    {fmt(p.totalMoney)}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </aside>

      {/* ── Round Transition (ranking summary) ── */}
      {roundTransition && (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/85">
          <div className="pixel-panel-gold p-6 sm:p-8 max-w-3xl w-[96%] anim-scale">
            <div className="text-center mb-10">
              <p className="text-4xl sm:text-5xl text-gradient-gold anim-neon">
                第 {round} 回合結束！
              </p>
            </div>
            <div className="space-y-1.5 mb-4">
              {ranked.map((p, rank) => (
                <div
                  key={p.id}
                  className={`flex items-center justify-between px-5 py-2 text-xl sm:text-2xl
                    ${rank === 0 ? "pixel-panel-gold" : "pixel-panel"}`}
                >
                  <div className="flex items-center gap-3">
                    <span className="w-10 flex justify-center">
                      {rank === 0 ? (
                        <PxIcon name="crown" size={28} />
                      ) : rank === 1 ? (
                        <span className="text-[#aabbcc]">#2</span>
                      ) : rank === 2 ? (
                        <span className="text-[#cc8844]">#3</span>
                      ) : (
                        <span className="text-[#445]">#{rank + 1}</span>
                      )}
                    </span>
                    <span
                      className={
                        rank === 0 ? "text-gradient-gold" : "text-gradient-cyan"
                      }
                    >
                      {p.name}
                    </span>
                  </div>
                  <span className="text-gradient-green">
                    {fmt(p.totalMoney)}
                  </span>
                </div>
              ))}
            </div>
            <button
              onClick={() => {
                sfxCtaClick();
                handleRoundTransitionConfirm();
              }}
              onMouseEnter={sfxHover}
              className="w-full py-3 pixel-btn-gold text-2xl sm:text-3xl"
            >
              進入第 {round + 1} 回合
            </button>
          </div>
        </div>
      )}

      {/* ── Result Modal (confirm to proceed) ── */}
      {resultModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/65">
          <div className="pixel-panel-gold px-12 py-10 text-center anim-scale max-w-3xl w-[96%]">
            <div className="mb-4 anim-bounce inline-block">
              <PxIcon name={resultModal.icon} size={96} />
            </div>
            <p className="text-5xl sm:text-6xl text-gradient-gold anim-neon">
              {resultModal.label}
            </p>
            {resultModal.extra && (
              <p className="text-2xl sm:text-3xl text-gradient-cyan mt-4">
                {resultModal.extra}
              </p>
            )}
            <button
              onClick={() => {
                sfxClick();
                dismissResult();
              }}
              onMouseEnter={sfxHover}
              className="mt-8 w-full py-3 pixel-btn-gold text-2xl sm:text-3xl"
            >
              確定
            </button>
          </div>
        </div>
      )}

      {/* ── Swap Execute Result (auto-dismiss) ── */}
      {swapExecuteResult && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/65">
          <div className="pixel-panel-gold px-10 py-8 text-center anim-scale max-w-3xl w-[96%]">
            <div className="mb-4 anim-bounce inline-block">
              <PxIcon name="swap" size={88} />
            </div>
            <p className="text-4xl sm:text-5xl text-gradient-purple anim-neon mb-4">
              交換完成！
            </p>
            <div className="space-y-3 text-2xl sm:text-3xl">
              <p>
                <span className="text-gradient-gold">
                  {swapExecuteResult.fromName}
                </span>
                {" → "}
                <span className="text-gradient-green">
                  {fmtResult(swapExecuteResult.fromGets)}
                </span>
              </p>
              <p>
                <span className="text-gradient-gold">
                  {swapExecuteResult.toName}
                </span>
                {" → "}
                <span className="text-gradient-green">
                  {fmtResult(swapExecuteResult.toGets)}
                </span>
              </p>
            </div>
            <button
              onClick={() => {
                sfxClick();
                dismissSwapResult();
              }}
              onMouseEnter={sfxHover}
              className="mt-8 w-full py-3 pixel-btn-gold text-2xl sm:text-3xl"
            >
              確定
            </button>
          </div>
        </div>
      )}

      <PeekConfirmModal
        show={showPeekConfirm}
        card={peekCard}
        onConfirm={handlePeekConfirm}
        onCancel={handlePeekCancel}
      />

      <QuizModal
        show={!!quizModal}
        question={quizModal?.question}
        options={quizModal?.options}
        onAnswer={handleQuizAnswer}
      />

      <SwapOfferModal
        show={showSwapOffer}
        playerName={swapOfferInfo?.playerName}
        currentValue={swapOfferInfo?.value}
        nextPlayerName={swapOfferInfo?.nextName}
        onAccept={handleSwapOfferAccept}
        onDecline={handleSwapOfferDecline}
      />

      <TurnStartModal
        show={awaitingTurnStart && !gameOver && !roundTransition}
        playerName={cur.name}
        roundInfo={`回合 ${round} / ${TOTAL_ROUNDS}`}
        onConfirm={handleTurnStartConfirm}
      />

      {gameOver && <FinalResults players={players} onRestart={handleRestart} />}
      {muteBtn}
    </div>
  );
}

export default App;
